<template>
  <div>
    <p data-testid="name">事業所名：{{ office.name }}</p>
    <p data-testid="staffName">事業所担当者名：{{ office.staffName }}</p>
    <p data-testid="phoneNumber">
      事業所電話番号：
      <a class="text-primary" :href="'tel:' + office.phoneNumber"
        >{{ office.phoneNumber }}
      </a>
    </p>
    <p data-testid="address">事業所住所：{{ office.address }}</p>
    <ConfirmRoute
      data-testid="confirmRoute"
      :latitude="office.latitude"
      :longitude="office.longitude"
      @confirm-route="confirmOfficeRoute"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import { Office } from "@/types/office/Office";
import { Prop } from "vue-facing-decorator";
import ConfirmRoute from "@/components/organisms/common/ConfirmRoute.vue";
import { openInNewWindow } from "@/utils/browserUtil";
import { makeGoogleMapConfirmRouteUrl } from "@/utils/googlemap";

@Component({
  components: {
    ConfirmRoute
  }
})
export default class ApplicationOfficeDetail extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  office!: Office;

  // 事業所へのルートを確認する
  confirmOfficeRoute() {
    /**
     * HACK: 本来はcordova-plugin-white-listで制限しているため自動で外部ブラウザに移動するが、googleMapのiframeの読み込みが必要なため、
     * googleMapのルートに移動する時だけプラグインを利用する
     *
     */
    openInNewWindow(
      makeGoogleMapConfirmRouteUrl(this.office.latitude, this.office.longitude)
    );
  }
}
</script>
